import { coreV1DeleteTransformMutation } from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useDeleteTransform = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: ({ name }: { name: string }) =>
      coreV1DeleteTransformMutation({
        ...defaultOptions(),
      }).mutationFn!({
        body: {},
        path: { name, workspace },
      }),
  });
};
